// src/components/FooterDefault.js

import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaHeart } from 'react-icons/fa';
import './Footer.css';
import { TabContext } from '../context/TabContext';
import { ScrollContext } from '../context/ScrollContext';
import { ModalContext } from '../context/ModalContext';

export default function FooterDefault() {
  const { activeTab, setActiveTab } = useContext(TabContext);
  const { homeScrollPosition } = useContext(ScrollContext);
  const { modalStacks, closeModal } = useContext(ModalContext);
  const navigate = useNavigate();

  const currentStack = modalStacks[activeTab] || [];

  // Opacidad dinámica
  const TH = 70;
  const [anchor, setAnchor] = useState(homeScrollPosition);
  const [direction, setDirection] = useState(null);
  const [lastScroll, setLastScroll] = useState(homeScrollPosition);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const y = homeScrollPosition;
    if (y < 5) {
      setOpacity(1);
      setAnchor(0);
      setLastScroll(y);
      return;
    }
    let dir = direction;
    if (y > lastScroll) dir = 'down';
    else if (y < lastScroll) dir = 'up';
    if (dir !== direction) {
      setAnchor(lastScroll);
      setDirection(dir);
    }
    const delta = Math.abs(y - anchor);
    let newOp = opacity;
    if (dir === 'down') newOp = delta < TH ? 1 - delta/TH : 0.3;
    else if (dir === 'up') newOp = delta < TH ? delta/TH : 1;
    setOpacity(newOp);
    setLastScroll(y);
  }, [homeScrollPosition, direction, lastScroll, anchor, opacity]);

  const bg = `rgba(41, 163, 255, ${
    (activeTab === 'likes' || currentStack.length > 0) ? 1 : opacity
  })`;

  const handleHome = () => {
    if (activeTab === 'likes') setActiveTab('home');
    else if (activeTab === 'home') {
      if (currentStack.length > 0) {
        // Si se cierra el ÚLTIMO modal, limpiamos la URL para que Header vuelva a Default
        if (currentStack.length === 1) {
          // Primero cerramos el último modal y luego navegamos a "/"
          closeModal('home');
          navigate('/', { replace: true });
        } else {
          // Si aún quedan más modales apilados (sub‐modales), cerramos solo uno
          closeModal('home');
        }
      } else {
        const c = document.querySelector('.home-container');
        if (c) c.scrollTo({ top: 0, behavior: 'smooth' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };
  const handleLikes = () => setActiveTab('likes');

  return (
    <footer className="footer" style={{ backgroundColor: bg }}>
      <div className="footer-section" onClick={handleHome}>
        <FaHome size={22} color="#fff" />
      </div>
      <div className="footer-section" onClick={handleLikes}>
        <FaHeart size={22} color="#fff" />
      </div>
    </footer>
  );
}
